import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showResults } from "../redux/locationsSelectorSagas";
import { CheckIcon, FilterSearchIcon, XIcon } from "../../../assets/images/svg";

export function SelectStore({ onClose }) {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const stores = useSelector((state) => state.locations.selectStoreFilters.stores);

  const allLocations = [
    { name: "All Stores", checked: stores.every((store) => store.checked) },
    ...stores
  ];

  const filteredLocations = search
    ? allLocations.filter((location) =>
        location.name.toLowerCase().includes(search.toLowerCase().trim())
      )
    : allLocations;

  const searchClear = (e) => {
    e.preventDefault();
    setSearch("");
  };

  const onStoreClick = ({ id, name }) => {
    dispatch(showResults({ id, name }));
  };

  return (
    <>
      <div className="location-selector__body">
        <div className="search">
          <input
            className="location-selector__input location-selector__input-search"
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="icon icon-search">
            <FilterSearchIcon />
          </div>

          {search && (
            <div className="icon icon-close" onClick={searchClear}>
              <XIcon />
            </div>
          )}
        </div>
        <div className="list">
          {filteredLocations.length
            ? filteredLocations.map(({ id, name, checked }) => (
                <div
                  className="list-option"
                  key={name + id}
                  onClick={() => onStoreClick({ id, name })}
                >
                  <div>{name}</div>
                  {checked ? (
                    <div className="list-icon">
                      <CheckIcon />
                    </div>
                  ) : null}
                </div>
              ))
            : null}
        </div>
        {search && filteredLocations.length === 0 && (
          <div className="location-selector__error">
            <div className="icon-content">
              <div className="icon-content__search">
                <FilterSearchIcon />
              </div>
            </div>
            <div className="text">We couldn’t find that location</div>
          </div>
        )}
      </div>

      <div className="location-selector__footer">
        <button className="button button--secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </>
  );
}
